import {
  SR_API_ACTION_GET_LISTING_LIST,
} from 'api/actionTypes';

import {
  makeListingsFilters,
} from 'common/listingHelpers';

export default function updateFilter({ apiClient, state }, { filterKey, filterValue }) {
  state.set(['search', 'filters', filterKey], filterValue);
  state.commit();

  const now = Date.now();
  const searchFilterArea = state.get(['search', 'filters', 'area']);

  state.set(['noResultsPinnedListings'], null);

  return apiClient.postWithState({
    action: SR_API_ACTION_GET_LISTING_LIST,
    state: state,
    payload: {
      page: 0,
      count: 1,
      onlyCount: true,
      filters: makeListingsFilters({
        user: {
          searchFilters: {
            ...state.get(['search', 'filters']),
            locationPoint: searchFilterArea ? [...searchFilterArea, searchFilterArea[0]] : undefined,
          },
        },
        market: state.get(['markets', 'currentUserMarket']),
      }),
    },
    queryId: String(now),
    onSuccess({ total }) {
      const previousResultsCountTimestamp = state.get(['search', 'resultsCountTimestamp']);
      if (previousResultsCountTimestamp && previousResultsCountTimestamp > now) {
        return;
      }
      state.set(['search', 'resultsCountTimestamp'], now);
      state.set(['search', 'resultsCount'], total);
    },
  });
}
